import { showElem, stopElemAnim, addCloseElemAnim, hideElem } from './utils';
import { timeout } from './utils';

const overlayTop = document.querySelector('.overlay-top');

const dropdownHandler = (btn, dropdown, overlay) => {
  btn.addEventListener('mouseenter', () => {
    clearTimeout(timeout.id);

    stopElemAnim(overlay);
    stopElemAnim(dropdown);

    showElem(overlay);
    showElem(dropdown);
  });

  btn.addEventListener('mouseleave', (e) => {
    hideElem(e.target.querySelector('[data-dropdown-elem="dropdown"]'));
    addCloseElemAnim(overlay);
    addCloseElemAnim(dropdown);

    timeout.id = setTimeout(() => {
      hideElem(dropdown);
      hideElem(overlay);
    }, 300);
  });
};

export const initDropdown = () => {
  const dropdowns = document.querySelectorAll('.header-cta, .header-account');
  const dropdownCTA = document.querySelector('.header-dropdown--cta');
  const dropdownAccount = document.querySelector('.header-dropdown--account');

  dropdowns.forEach((btn) => {
    if (btn.classList.contains('header-cta')) {
      dropdownHandler(btn, dropdownCTA, overlayTop);
    }
    if (btn.classList.contains('header-account')) {
      dropdownHandler(btn, dropdownAccount, overlayTop);
    }
  });
};
